import { defineMessages } from 'react-intl';

const messages = defineMessages({
  showInactiveLabel: {
    description: 'Checkbox to display inactive vendors',
    defaultMessage: 'Show Inactive',
    id: 'GkbwyZ',
  },
});

export default messages;
